import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';

const GridContainer = ({ children, ...rest }) => {
  return (
    <Grid container {...rest}>
      {children}
    </Grid>
  );
};

GridContainer.propTypes = {
  children: PropTypes.any
};

export default GridContainer;
